import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import prevNextStyles from './prevNext.module.css';
import back from '../../assets/back.png';
import forward from '../../assets/forward.png';

const transitionProps: string = 'all 1.75s ease';

interface btnAnimateStyle {
  margin?: string;
  width?: string;
  transition?: string;
  position?: string;
  left?: string;
};

interface ButtonProps {
  active: boolean;
  href?: string;
  animate?: boolean;
  onClick?: () => void;
};

interface PrevNextProps {
  prevButton?: ButtonProps,
  nextButton?: ButtonProps
};

interface PrevNextState {
  prevAnimateStyle: btnAnimateStyle;
  nextAnimateStyle: btnAnimateStyle;
};

class PrevNext extends Component<PrevNextProps, PrevNextState> {

  prevTimeOut: any;
  nextTimeOut: any;

  state = {
    prevAnimateStyle: {
      position: 'relative' as 'relative',
      left: '127px',
      transition: transitionProps
    },
    nextAnimateStyle: {
      width: '116px',
      transition: transitionProps
    },
    prevTimeOut: undefined,
    nextTimeOut: undefined
  }

  componentDidMount() {

    this.prevButtonAnimation();
    this.nextButtonAnimation();
  }

  prevButtonAnimation = (): void => {

    const prevButton: ButtonProps | undefined = this.props.prevButton;
    const currPrevAnimateStyle: btnAnimateStyle = { ...this.state.prevAnimateStyle };
    currPrevAnimateStyle.left = '127';

    if (prevButton && prevButton.animate) {

      const currPrevAnimateStyle: btnAnimateStyle = { ...this.state.prevAnimateStyle };

      this.prevTimeOut = setTimeout(() => {
  
        currPrevAnimateStyle.left = '0';
        this.setState({ prevAnimateStyle: currPrevAnimateStyle });
      }, 100);

    } else {

      currPrevAnimateStyle.left = '0';
      this.setState({ prevAnimateStyle: currPrevAnimateStyle });
    }

    this.setState({ prevAnimateStyle: currPrevAnimateStyle });
  }

  nextButtonAnimation = (): void => {

    const nextButton: ButtonProps | undefined = this.props.nextButton;
    const currNextAnimateStyle: btnAnimateStyle = { ...this.state.nextAnimateStyle };

    if (nextButton && nextButton.animate) {

      currNextAnimateStyle.width = '216px';
      this.setState({ nextAnimateStyle: currNextAnimateStyle });

      this.nextTimeOut = setTimeout(() => {

        const currNextAnimateStyle: btnAnimateStyle = { ...this.state.nextAnimateStyle };

        currNextAnimateStyle.width = '116px';
        this.setState({ nextAnimateStyle: currNextAnimateStyle });
      }, 100);
    }
  }

  componentWillUnmount() {

    clearTimeout(this.prevTimeOut);
    clearTimeout(this.nextTimeOut);
  }

  render () {

    const { prevButton, nextButton } = this.props;

    return (
      <Fragment>
        <div className={ prevNextStyles.buttonsCoverDiv } ></div>

        <div className={ prevNextStyles.flex } >

          <div className={ prevNextStyles.btnWrapper } >
            { prevButton && prevButton.active &&
              <div style={ this.state.prevAnimateStyle } >
                { prevButton.onClick ? (
                  <button
                    onClick={ prevButton.onClick }
                    className={ prevNextStyles.prevButton }
                  >
                    <div className={ prevNextStyles.imageWrapper } >
                      <img src={ back } alt={ 'back' } />
                    </div>
                  </button>
                ) : (
                  <Link to={ prevButton.href || '/' } >
                    <div className={ prevNextStyles.imageWrapper } >
                      <img src={ back } alt={ 'back' } />
                    </div>
                  </Link>
                )}
              </div>
            }
          </div>

          { nextButton && nextButton.active && 
          <div style={ this.state.nextAnimateStyle } >
            { nextButton.onClick ? (
                <button
                  onClick={ nextButton.onClick }
                  className={ prevNextStyles.nextButton }
                >
                  <div className={ prevNextStyles.imageWrapper } >
                    <img src={ forward } alt={ 'forward' } />
                  </div>
                </button>
              ) : (
                <Link to={ nextButton.href || '/' } >
                  <div className={ prevNextStyles.imageWrapper } >
                    <img src={ forward } alt={ 'forward' } />
                  </div>
                </Link>
              )}
            </div>
            }

        </div>
      </Fragment>
    )
  };
}

export default PrevNext;